/*eslint-disable*/
import React from "react";

// reactstrap components
import { Button, Container, Row, Col, UncontrolledTooltip } from "reactstrap";

class Download extends React.Component {
  render() {
    return (
      <>
        <section className="section section-lg">
          <Container>
            <Row className="row-grid justify-content-center">
              <Col className="text-center" lg="8">
                <div className="text-center">
                  <h4 className="display-4 mb-5 mt-5">
                    I use these technologies
                  </h4>
                  <Row className="justify-content-center">
                    <Col lg="2" xs="4">
                      <a
                        href="https://nodejs.org"
                        id="tooltip255035741"
                        target="_blank"
                      >
                        <img
                          alt="Node.js"
                          className="img-fluid"
                          src={require("assets/img/theme/nodejs.png")}
                          style={{ maxWidth: "60%", marginTop: "1.2em" }}
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip255035741">
                        Node.js - a JavaScript runtime built on Chrome's V8
                        JavaScript engine
                      </UncontrolledTooltip>
                    </Col>
                    <Col lg="2" xs="4">
                      <a
                        href="https://wwww.vuejs.org"
                        id="tooltip265846671"
                        target="_blank"
                      >
                        <img
                          alt="Vue.js"
                          className="img-fluid"
                          src={require("assets/img/theme/vue.jpg")}
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip265846671">
                        Vue.js - The progressive javascript framework
                      </UncontrolledTooltip>
                    </Col>
                    <Col lg="2" xs="4">
                      <a
                        href="https://angularjs.org"
                        id="tooltip233150499"
                        target="_blank"
                      >
                        <img
                          alt="Angular"
                          className="img-fluid"
                          src={require("assets/img/theme/angular.jpg")}
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip233150499">
                        Angular - One framework. Mobile & Desktop
                      </UncontrolledTooltip>
                    </Col>
                    <Col lg="2" xs="4">
                      <a
                        href="https://reactjs.org"
                        id="tooltip308866163"
                        target="_blank"
                      >
                        <img
                          alt="React/React Native"
                          className="img-fluid"
                          src={require("assets/img/theme/react.jpg")}
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip308866163">
                        React/React Native - A JavaScript library for building
                        user interfaces
                      </UncontrolledTooltip>
                    </Col>
                    <Col lg="2" xs="4">
                      <a
                        href="https://sailsjs.com"
                        id="tooltip76119384"
                        target="_blank"
                      >
                        <img
                          alt="Sails.js"
                          className="img-fluid"
                          src={require("assets/img/theme/sailsjs.png")}
                          style={{ maxWidth: "55%", marginTop: "1em" }}
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip76119384">
                        Sails.js - the most popular MVC framework for Node.js
                      </UncontrolledTooltip>
                    </Col>
                    <Col lg="2" xs="4">
                      <a
                        href="https://meteor.com"
                        id="tooltip646643508"
                        target="_blank"
                      >
                        <img
                          alt="Meteor.js"
                          className="img-fluid"
                          src={require("assets/img/theme/meteor.png")}
                          style={{ maxWidth: "80%", marginTop: "0.4em" }}
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip646643508">
                        Meteor.js - an open source platform for web, mobile, and
                        desktop
                      </UncontrolledTooltip>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </>
    );
  }
}

export default Download;
